import AuthenticationLayout from './AuthenticationLayout';
export default AuthenticationLayout;
